module.exports = "/assets/fcc6ce1ee448ccf3b5a8226e93702e9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/7G.png
// module id = 1110
// module chunks = 0